import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import image from '../../../images/data-science.png';

const WorksDetailsTop = () => {
    return (
        <>
            <Box sx={{ my: { xs: '10px', sm: '25px' }, pb: { lg: '15px' } }}>
                <CardMedia
                    component="img"
                    image={image}
                    alt="data science"
                />
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    How It <span style={{ fontWeight: 700, color: '#433ED1' }}>Works</span>
                </Typography>
            </Box>

            {/* details */}
            <Box sx={{ px: { xs: '5px', sm: '17px', md: '27px', lg: '50px', xl: '70px' }, mt: { sm: '12px', lg: '20px' }, mb: '28px' }}>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '16px', md: '17px', lg: '18px' }, lineHeight: { xs: '30px', lg: '34px' }, color: '#383838', textAlign: 'left' }}>
                    A hypergraph is the movement of data in a decentralized network that has a token attached to it. It provides immutability, scalability, and security which helps businesses store data. DAG is not linear and expands in multiple directions at the same time leading to high scalability and blazing fast. With Quantally it makes sense to hold the token forever since Quantally uses a community-first approach that makes the network formidable and accrues value to the token.
                </Typography>
            </Box>
        </>
    );
};

export default WorksDetailsTop;